import commonConstants from './constants';

interface SubmitPayload {
    source: string;
    name: string;
    mobileNo: string;
    message: string;
  }
  
  const submitToSheet = async (payload: SubmitPayload) => {
    try {
      const params = new URLSearchParams({
      source: payload.source,
      timestamp: new Date().toISOString(),
      name: payload.name,
      mobileNo: payload.mobileNo,
      message: payload.message,
    });
      await fetch(`${commonConstants.google_sheet_deployed_url}?${params.toString()}`, {
        method: 'GET',
        mode: 'no-cors',
      });
  
      // With no-cors mode, we can't read the response
      // So we assume success if no error is thrown
      return { success: true };
    } catch (error) {
      console.error('Error submitting to sheet:', error);
      throw error;
    }
  };
  
  export default submitToSheet;